import { useForm } from 'react-hook-form';
import { InsightSummaryType } from '../queries/useInsightsSummaryQuery';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export type InsightSummaryFormData = {
  description: string;
  divisionChips: string[];
  divisions: string[];
  specSectionChips: string[];
  specSections: string[];
  title: string;
};

const InsightSummaryFormSchema = Yup.object().shape({
  description: Yup.string(),
  divisionChips: Yup.array(Yup.string()),
  divisions: Yup.array(Yup.string()),
  specSectionChips: Yup.array(Yup.string()),
  specSections: Yup.array(Yup.string()),
  title: Yup.string().required('Title is required'),
});

function useInsightSummaryForm({ insightSummary }: { insightSummary?: InsightSummaryType }) {
  const insightSummaryForm = useForm<InsightSummaryFormData>({
    mode: 'onChange',
    resolver: yupResolver(InsightSummaryFormSchema),
    defaultValues: getDefaultValues(),
  });

  function getDefaultValues(): InsightSummaryFormData {
    return {
      description: insightSummary?.description || '',
      divisionChips: [],
      divisions: [],
      specSectionChips: [],
      specSections: [],
      title: insightSummary?.title || '',
    };
  }

  return {
    insightSummaryForm,
  };
}

export default useInsightSummaryForm;
